export const DISABLED_MSG_TEXT = "Denna funktion är ej tillgänglig vid körning via plugin.";
export const COMPLETED_SHUNT_API = "Klicka på Insert för att färdigställa shuntgruppen.";